import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import DownloadIcon from '@mui/icons-material/Download';
import '../assets/styles/Main.scss';
import aboutImg from '../assets/images/about.png'; // ✅ your image

function Main() {
  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={aboutImg} alt="Utkarsh Gupta" />
        </div>

        <div className="content">
          {/* --- Desktop Social Icons --- */}
          <div className="social_icons">
            <a href="https://github.com/2002utkarsh" target="_blank" rel="noreferrer">
              <GitHubIcon />
            </a>
            <a href="https://www.linkedin.com/in/utkarsh-gupta424/" target="_blank" rel="noreferrer">
              <LinkedInIcon />
            </a>
            <a href="mailto:utkarsh.gupta424@gmail.com" target="_blank" rel="noreferrer">
              <EmailIcon />
            </a>
          </div>

          <h1>Utkarsh Gupta</h1>
          <p>Software Engineering Student</p>
          <p className="bio">
            Building reliable software from low-level firmware to distributed cloud services.
          </p>

          <a href="/Utkarsh_Gupta_Resume.pdf" download className="resume-btn">
            <DownloadIcon /> Download Resume
          </a>

          {/* --- Mobile Social Icons --- */}
          <div className="mobile_social_icons">
            <a href="https://github.com/2002utkarsh" target="_blank" rel="noreferrer">
              <GitHubIcon />
            </a>
            <a href="https://www.linkedin.com/in/utkarsh-gupta424/" target="_blank" rel="noreferrer">
              <LinkedInIcon />
            </a>
            <a href="mailto:utkarsh.gupta424@gmail.com" target="_blank" rel="noreferrer">
              <EmailIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
